// TODO: Investigate why @shared/constants cannot be resolved here, despite working in Resto.
import * as sharedConstants from '../../shared/constants';
export * from '../../shared/constants';

import { IVehicleSelection } from '@shared/types/IVehicleSelection';
import { IVehicleFilters } from '@unified-commerce/gpc-vue-storefront-search';

export const PRODUCT_CARD_ALT_IMG = 'amx-logo.svg';
export const PRODUCT_DELIVERY_ESTIMATE_MESSAGE = 'Estimated to arrive on';
export const BRAND_FULL_NAME = 'AMX Superstores';
export const SEARCH_CATEGORY_TENANT_PREFIX = 'amx-categories';
export const SEARCH_CATEGORY_TENANT_PREFIX_TITLE = 'AMX Categories';
export const SEARCH_CATEGORY_TENANT_PREFIX_HANDLE = 'amx-categories-';
export const SEARCH_CATEGORY_PROMOTIONS_PREFIX_HANDLE = 'promotions-';
export const SEARCH_CATEGORY_PATH_SEPERATOR = '>';
export const SEARCH_TOP_LEVEL_PROMOTION_CATEGORY_TITLE = `${SEARCH_CATEGORY_TENANT_PREFIX_HANDLE}promotions`;
export const PROMOTION_CATEGORY_SPLIT = 'Promotions>';
export const SEARCH_PROMOTION_ACTIVE_TAG = 'sales_promo_active';
export const CLEARANCE_TAG = 'clearance';
export const SEARCH_CATEGORY_HANDLE_SEPARATOR = '-';
export const SEARCH_CATEGORY_QUERY_SEPARATOR = '/';
export const SEARCH_BRAND_PREFIX_TITLE = 'AMX Categories>Brand Categories';
export const SEARCH_BRAND_PREFIX_HANDLE = `${SEARCH_CATEGORY_TENANT_PREFIX_HANDLE}brand-categories`;
export const SEARCH_DEFAULT_TITLE_OPTION = 'Default Title';
export const BASE_SEARCH_PATH = '/search';
export const BRANDS_CATEGORY_IDENTIFIER = 'Brands';
export const BRAND_CATEGORIES_CATEGORY_IDENTIFIER = 'Brand Categories';
export const BRAND = 'AMX';
export const CATEGORY_ROUTE_PREFIX = 'motorcycle-gear';
export const STORYBLOK_SETTINGS = 'settings';
export const STORYBLOK_CATEGORY_ROUTE_PREFIX = `content/categories`;
export const IS_LOGIN_FROM_CHECKOUT_QUERY_PARAM = 'from-checkout';
export const IS_LOGIN_FROM_CHECKOUT_COOKIE = 'isloginfromcheckout';
export const PAGE_QUERY_PARAM = 'page';
export const PER_PAGE_QUERY_PARAM = 'per-page';
export const PRICE_RANGE_QUERY_PARAM = 'price-range';
export const QUANTITY_QUERY_PARAM = 'quantity';
export const SEARCH_VARIANT_INVENTORY_COUNT_FIELD = 'variants_inventory_count';
export const MAX_PRICE_RANGE_QUERY_PREFIX = 'up-to-';
export const MIN_PRICE_RANGE_QUERY_PREFIX = 'above-';
export const SEARCH_QUERY_PARAM = 'q';
export const PRODUCT_TYPE_QUERY_PARAM = 'product_type';
export const SIZE_OPTION_QUERY_PARAM = 'size';
export const COLOUR_OPTION_QUERY_PARAM = 'colour';
export const VENDOR_QUERY_PARAM = 'vendor';
export const ON_SALE_KEY = 'tags';
export const ON_SALE_QUERY_PARAM = 'on_sale';
export const HIDDEN_PRODUCT_TAG = 'hidden_product';
export const STYLE_FILTER_KEY = 'variant_metafield_plytix_amx_style';
export const PART_NUMBER_FILTER_KEY = 'meta.plytix.part_number';
export const STYLE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_style';
export const MADE_TO_ORDER_FILTER = 'meta.plytix.made_to_order';
export const SAFETY_RATING_METAFIELD_FILTER_KEY = 'meta.plytix.amx_safety_rating';
export const SAFETY_RATING_FILTER_KEY = 'variant_metafield_plytix_amx_safety_rating';
export const MATERIAL_METAFIELD_FILTER_KEY = 'meta.plytix.material';
export const MATERIAL_FILTER_KEY = 'variant_metafield_plytix_material';
export const HELMET_TYPE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_helmet_type';
export const HELMET_TYPE_FILTER_KEY = 'variant_metafield_plytix_amx_helmet_type';
export const FASTENER_TYPE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_fastener_type';
export const FASTENER_TYPE_FILTER_KEY = 'variant_metafield_plytix_amx_fastener_type';
export const OIL_GRADE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_oil_grade';
export const OIL_GRADE_FILTER_KEY = 'variant_metafield_plytix_amx_oil_grade';
export const RIDING_TYPE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_riding_type';
export const RIDING_TYPE_FILTER_KEY = 'variant_metafield_plytix_amx_riding_type';
export const SEASONS_METAFIELD_FILTER_KEY = 'meta.plytix.amx_seasons';
export const SEASONS_FILTER_KEY = 'variant_metafield_plytix_amx_seasons';
export const TYRE_TYPE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_tyre_type';
export const TYRE_TYPE_FILTER_KEY = 'variant_metafield_plytix_amx_tyre_type';
export const NUM_OF_CHAIN_LINKS_METAFIELD_FILTER_KEY = 'meta.plytix.amx_number_of_chain_links';
export const NUM_OF_CHAIN_LINKS_FILTER_KEY = 'variant_metafield_plytix_amx_number_of_chain_links';
export const SPROCKET_TEETH_METAFIELD_FILTER_KEY = 'meta.plytix.amx_sprocket_teeth';
export const SPROCKET_TEETH_FILTER_KEY = 'variant_metafield_plytix_amx_sprocket_teeth';
export const CAPACITY_METAFIELD_FILTER_KEY = 'meta.plytix.amx_channel_capacity';
export const CAPACITY_FILTER_KEY = 'variant_metafield_plytix_amx_channel_capacity';
export const RIM_SIZE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_channel_rim_size';
export const RIM_SIZE_FILTER_KEY = 'variant_metafield_plytix_amx_channel_rim_size';
export const RIM_WIDTH_METAFIELD_FILTER_KEY = 'meta.plytix.amx_channel_rim_width';
export const RIM_WIDTH_FILTER_KEY = 'variant_metafield_plytix_amx_channel_rim_width';
export const TYRE_RIM_FIT_METAFIELD_FILTER_KEY = 'meta.plytix.amx_channel_tyre_rim_fit';
export const TYRE_RIM_FIT_FILTER_KEY = 'variant_metafield_plytix_amx_channel_tyre_rim_fit';
export const TYRE_PROFILE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_tyre_profile';
export const TYRE_PROFILE_FILTER_KEY = 'variant_metafield_plytix_amx_tyre_profile';
export const TYRE_WIDTH_METAFIELD_FILTER_KEY = 'meta.plytix.amx_channel_tyre_width';
export const TYRE_WIDTH_FILTER_KEY = 'variant_metafield_plytix_amx_channel_tyre_width';
export const OIL_TYPE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_oil_type';
export const OIL_TYPE_FILTER_KEY = 'variant_metafield_plytix_amx_oil_type';
export const CHAIN_SIZE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_chain_size';
export const CHAIN_SIZE_FILTER_KEY = 'variant_metafield_plytix_amx_chain_size';
export const AGE_METAFIELD_FILTER_KEY = 'meta.plytix.amx_age';
export const AGE_FILTER_KEY = 'variant_metafield_plytix_amx_age';
export const GENDER_METAFIELD_FILTER_KEY = 'meta.plytix.amx_gender';
export const GENDER_FILTER_KEY = 'variant_metafield_plytix_amx_gender';
export const SORT_BY_QUERY_PARAM = 'sort-by';
export const VEHICLE_IDS_FILTER_KEY = 'meta.fitment.vehicles';
export const SEARCH_DERIVED_IN_STOCK_FIELD = 'inventory_available';
export const PROMOTION_CATEGORY_PREFIX_TITLE = 'Promotion';
export const BRAND_CATEGORY_PREFIX_TITLE = 'Brand';
export const SUBCATEGORY_TILES_TITLE_SUFFIX = 'by Range';

export const HANDLING_TIME_COPY_DEFAULT = 'This part dispatches same day.';
export const HANDLING_TIME_SUFFIX =
  'to be ordered in from our supplier. It will then be dispatched to you and take additional time to be delivered.';
export const SPECIAL_ORDER_BADGE_COPY = '';
export const SPECIAL_ORDER_TOOLTIP_COPY = '';
export const OUT_OF_STOCK_TEXT_COPY = '';
export const OUT_OF_STOCK_TOOLTIP_COPY = '';
export const FITMENT_SHOP_PARTS_PATH = `/${CATEGORY_ROUTE_PREFIX}/parts-and-maintenance`;
export const GIFT_CARDS_PATH = `/${CATEGORY_ROUTE_PREFIX}/gift-cards`;

export const FILTER_MAKES = {};
export const FITMENT = {
  EMPTY_MESSAGE: 'This product can be bike specific. Add your bike to check what fits.',
  EMPTY_MESSAGE_PLURAL:
    'The following products can be bike specific. Add your bike to check what fits.',
  SELECTED_VEHICLE_MESSAGE: 'Selected bike in your garage:',
  SHOW_PARTS_THAT_FIT_MESSAGE: 'Only show parts that fit this bike:',
  FITS_MESSAGE: 'Guaranteed to fit your bike',
  FITS_MESSAGE_SHORT: 'Fits your bike',
  DOES_NOT_FIT_MESSAGE: "This doesn't fit your bike",
  ADD_VEHICLE: 'Add a bike',
  CHANGE_VEHICLE_BUTTON: 'Change bike',
  DOES_NOT_FIT_BUTTON: 'Shop what fits',
  REMOVE_VEHICLE: 'Remove bike',
  INFO_MESSAGE:
    'Take advantage of our hassle-free Fitment Guarantee and 60 DAY FREE RETURNS for any items that don’t fit as expected',
};

export const STOCK_STATUS = {
  ...sharedConstants.STOCK_STATUS,
  IN_STOCK: 'Available for delivery',
  SUPPORT_TEXT_WITH_STOCK: 'Check store stock',
  SUPPORT_TEXT_NO_STOCK: '',
};

export const ADDITIONAL_PRODUCT_FIELDS = [
  { name: 'relatedProducts', field: 'related_products' },
  { name: 'material', field: 'material' },
  { name: 'materialThickness', field: 'material_thickness' },
  { name: 'armour', field: 'amx_armour' },
  { name: 'batteryType', field: 'amx_battery_type' },
  { name: 'connectivity', field: 'amx_connectivity' },
  { name: 'externalVisor', field: 'amx_external_visor' },
  { name: 'fastenerType', field: 'amx_fastener_type' },
  { name: 'helmetType', field: 'amx_helmet_type' },
  { name: 'inTheBox', field: 'amx_in_the_box' },
  { name: 'internalVisor', field: 'amx_internal_visor' },
  { name: 'motor', field: 'amx_motor' },
  { name: 'mpn', field: 'amx_mpn' },
  { name: 'oilGrade', field: 'amx_oil_grade' },
  { name: 'packagingHeightCm', field: 'amx_packaging_height_cm' },
  { name: 'ridingType', field: 'amx_riding_type' },
  { name: 'safetyRating', field: 'amx_safety_rating' },
  { name: 'seasons', field: 'amx_seasons' },
  { name: 'speakerPockets', field: 'amx_speaker_pockets' },
  {
    name: 'sunglassesGlassesGrooves',
    field: 'amx_sunglasses_glasses_grooves',
  },
  { name: 'packagingLengthCm', field: 'amx_packaging_length_cm' },
  { name: 'pattern', field: 'amx_pattern' },
  { name: 'uvProtection', field: 'amx_uv_protection' },
  { name: 'ventilation', field: 'amx_ventilation' },
  { name: 'packagingWeightKg', field: 'amx_packaging_weight_kg' },
  { name: 'waterproof', field: 'amx_waterproof' },
  { name: 'packagingWidthCm', field: 'amx_packaging_width_cm' },
  { name: 'productHeightCm', field: 'amx_product_height_cm' },
  { name: 'bootType', field: 'amx_boot_type' },
  { name: 'shoeWidth', field: 'amx_shoe_width' },
  { name: 'tyreType', field: 'amx_tyre_type' },
  { name: 'productLengthCm', field: 'amx_product_length_cm' },
  { name: 'productWeightKg', field: 'amx_product_weight_kg' },
  { name: 'productWidthCm', field: 'amx_product_width_cm' },
  { name: 'sprocketTeeth', field: 'amx_sprocket_teeth' },
  { name: 'tyreProfile', field: 'amx_tyre_profile' },
  { name: 'chainSize', field: 'amx_chain_size' },
  {
    name: 'frontSprocketSplineType',
    field: 'amx_front_sprocket_spline_type',
  },
  {
    name: 'numberOfChainLinks',
    field: 'amx_number_of_chain_links',
  },
  {
    name: 'torque',
    field: 'amx_channel_torque',
  },
  {
    name: 'batteryLife',
    field: 'amx_channel_battery_life',
  },
  {
    name: 'bcd',
    field: 'amx_channel_bcd',
  },
  {
    name: 'capacity',
    field: 'amx_channel_capacity',
  },
  {
    name: 'externalDiameter',
    field: 'amx_channel_external_diameter',
  },
  {
    name: 'hubWidth',
    field: 'amx_channel_hub_width',
  },
  {
    name: 'insideDiameter',
    field: 'amx_channel_inside_diameter',
  },
  {
    name: 'maxSpeed',
    field: 'amx_channel_max_speed',
  },
  {
    name: 'rimSize',
    field: 'amx_channel_rim_size',
  },
  {
    name: 'rimWidth',
    field: 'amx_channel_rim_width',
  },
  {
    name: 'tyreRimFit',
    field: 'amx_channel_tyre_rim_fit',
  },
  {
    name: 'tyreWidth',
    field: 'amx_channel_tyre_width',
  },
  {
    name: 'voltage',
    field: 'amx_channel_voltage',
  },
  {
    name: 'wattage',
    field: 'amx_channel_wattage',
  },
  {
    name: 'weightLimit',
    field: 'amx_channel_weight_limit',
  },
  {
    name: 'helmetWeight',
    field: 'amx_channel_helmet_weight',
  },
  {
    name: 'oilType',
    field: 'amx_oil_type',
  },
];

export const SORT_OPTION_LIST = [
  {
    label: 'Most Relevant',
    value: 'most_relevant',
    queryParamName: 'most_relevant',
  },
  {
    label: 'Alphabetically, A - Z',
    value: 'title-ascending',
    queryParamName: 'title-ascending',
  },
  {
    label: 'Alphabetically, Z - A',
    value: 'title-descending',
    queryParamName: 'title-descending',
  },
  {
    label: 'Price, low - high',
    value: 'price-ascending',
    queryParamName: 'price-ascending',
  },
  {
    label: 'Price, high - low',
    value: 'price-descending',
    queryParamName: 'price-descending',
  },
  {
    label: 'Date, old - new',
    value: 'created-ascending',
    queryParamName: 'created-ascending',
  },
  {
    label: 'Date, new - old',
    value: 'created-descending',
    queryParamName: 'created-descending',
  },
];
export const APP_ICON_PATH = '~/static/icons/amx-app-icon-512x512.png';

// Vehicle selection
export const FORM_FIELD_CONFIG: IVehicleSelection[] = [
  {
    title: 'Make',
    label: 'MAKE',
    queryField: 'make' as keyof IVehicleFilters,
    isDisabled: false,
    options: [],
  },
  {
    title: 'Model',
    label: 'MODEL',
    queryField: 'model' as keyof IVehicleFilters,
    isDisabled: true,
    options: [],
  },
  {
    title: 'Year',
    label: 'YEAR',
    queryField: 'year' as keyof IVehicleFilters,
    isDisabled: true,
    options: [],
  },
];

export const PRODUCT_BACKORDER_MESSAGE = '';

export const FOOTER_HEADINGS = {
  ABOUT: 'About',
  SUPPORT: 'Help & Contact',
  ACCOUNT: 'Account',
  SHOP: 'Shop',
  SOCIAL_MEDIA: 'Connect with us',
};
